import {ChangeDetectionStrategy, Component, input, InputSignal, OnInit} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {MatCard, MatCardContent} from '@angular/material/card';
import {MatTooltip} from '@angular/material/tooltip';
import {Observable} from 'rxjs';

// @TODO: deprecated
// import moment, {Moment} from 'moment/moment';

import {GameModel} from 'shared/models';
import {ConfigService} from '../../../config.service';

@Component({
  selector: 'game-ui',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, MatCard, MatCardContent, MatTooltip],
  templateUrl: './game-ui.html',
  styleUrl: './game-ui.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameUi implements OnInit {
  game: InputSignal<GameModel> = input.required<GameModel>();
  index: InputSignal<number> = input.required<number>();

  protected bucketUrl!: string;

  protected duration$!: Observable<string>;

  constructor(
    // @TODO
    // protected themeService: CustomizerSettingsService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.bucketUrl = this.configService.config.bucketUrl;

    this.initDurationObs();
  }

  /**
   * Contador regresivo
   */
  // foo1(): void {
  //   const hour = 1;
  //
  //   let distance = (hour * 60 * 60 * 1000) - 1000;
  //
  //   this.duration$ = timer(0, 1000).pipe(
  //     takeUntil(timer(distance)),
  //     map(() => {
  //       const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //       const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //       const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //       const seconds = Math.floor((distance % (1000 * 60)) / 1000);
  //       distance -= 1000;
  //       return `${days ? days + 'd' : ''} ${hours ? hours + 'h' : ''} ${minutes ? minutes + 'm' : ''} ${seconds ? seconds + 's' : ''}`;
  //     })
  //   );
  // };

  // foo2(): void {
  //   const startDate: Moment = moment(this.game().startDate);
  //   const now: Moment = moment();
  //   const diff: number = now.diff(startDate, 'seconds');
  //
  //   let distance = diff * 1000;
  //   const period = 1000;
  //
  //   this.duration$ = timer(0, period).pipe(
  //     map(() => {
  //       const hours: number = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //       const minutes: number = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //       const seconds: number = Math.floor((distance % (1000 * 60)) / 1000);
  //       distance += period;
  //       return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  //     })
  //   );
  // }

  initDurationObs(): void {
    // @TODO: descomentar
    // const startDate: Moment = moment(this.game().startDate);
    // const period = 60000;
    // this.duration$ = timer(0, period).pipe(
    //   // @TODO: mientras el estado del partido sea "in_progress"
    //   // takeUntil(timer(distance)),
    //   map(() => {
    //     const now: Moment = moment();
    //     const diff: number = now.diff(startDate, 'minutes');
    //     const hours: number = Math.floor(diff / 60);
    //     const minutes: number = diff % 60;
    //     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    //   })
    // );
  };
}
